import Vue from "vue";

export default {
  async get(table, data) {
    const params = new URLSearchParams(data).toString();

    const response = await Vue.axios.get(`data/${table}?${params}&withGeom`);
    return response.data;
  }
};
